export default "__VITE_ASSET__89149c0e__"